import { ReactNode } from "react";
import { Link } from "react-router-dom";
import styles from "./Layout.module.css";
import { Label, Stack } from "@fluentui/react";
import EuCo from "../../assets/EuCo.svg";
import HeaderButtons from "../HeaderButtons/HeaderButtons";
import { DEFAULT_USE_CASE_NAME } from "../../utils/constants";

type LayoutProps = {
  children: ReactNode;
  toggleSpinner: boolean;
  showHistoryBtn: boolean;
  showHistoryPanel: boolean;
  conversationId: string;
  showExport: boolean;
  useCaseTitle: string;
  dgName: string;
  dgLabel?: string;
  onSetShowHistoryPanel: () => void;
  onUseInternetChange: (checked: boolean) => void;
  onExport: (id: string, format: string) => Promise<void>;
  onFolderStructureChanged: (folderNumber: number) => void;
  onLogoClick: () => void;
  onDgSwitch: (dg: string, displayName?: string) => void;
};

const Layout = ({
  children,
  toggleSpinner,
  conversationId,
  showExport,
  useCaseTitle,
  dgName,
  dgLabel,
  onFolderStructureChanged,
  onLogoClick,
  onUseInternetChange,
  onExport,
  onDgSwitch,
  ...props
}: LayoutProps) => {
  const { showHistoryPanel, showHistoryBtn, onSetShowHistoryPanel } = props;

  return (
    <div className={styles.layout}>
      <header className={styles.header} role={"banner"}>
        <div className={styles.headerContainer}>
          <Stack horizontal verticalAlign="center">
            <img
              src={EuCo}
              className={styles.headerIcon}
              aria-hidden="true"
              alt="European Commission logo"
            />
            <Link
              to="/"
              className={styles.headerTitleContainer}
              onClick={onLogoClick}
            >
              <h3 className={styles.headerTitle}>{dgLabel ?? dgName} AI Assistant</h3>
            </Link>
            <HeaderButtons
              showHistoryBtn={showHistoryBtn}
              showHistoryPanel={showHistoryPanel}
              onSetShowHistoryPanel={onSetShowHistoryPanel}
              conversationId={conversationId}
              onUseInternetChange={onUseInternetChange}
              onExport={onExport}
              showExport={showExport}
              onFolderStructureChanged={onFolderStructureChanged}
              useCaseTitle={useCaseTitle}
              currentDg={dgName}
              onDgSwitch={onDgSwitch}
            />
          </Stack>
        </div>
      </header>
      {useCaseTitle != DEFAULT_USE_CASE_NAME && (
        <div className={styles.workflowBar}></div>
      )}
      {children}
    </div>
  );
};

export default Layout;
